import { IconTile } from "@/components/ui/IconTile";
import { plural } from "@/lib/plural";

/**
 * The red count of what waits on a rail row or a tab, as v0.28 draws it.
 * The tile is drawn for the eye; a reader hears the count in words.
 */
export function CountMark({
  count,
  noun = "suggested change",
}: {
  count: number;
  /** What is counted, as a reader hears it. */
  noun?: string;
}) {
  const said = plural(count, noun);
  return (
    <span className="ml-auto flex-none">
      <IconTile tone="alert" shape="round" size="xs" numeral={count} />
      <span className="sr-only">{said}</span>
    </span>
  );
}
